import { motion } from 'framer-motion';

const PrivacyPage = () => {
  return (
    <div className="bg-revo-bg pt-20 min-h-screen">
      {/* Hero */}
      <section className="py-16 md:py-24 border-b border-revo-border">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <span className="font-manrope text-sm text-revo-orange uppercase tracking-widest">
              Informativa sulla Privacy
            </span>
            <h1 className="font-barlow text-4xl md:text-5xl font-bold uppercase tracking-tight text-white mt-4">
              Privacy Policy
            </h1>
            <p className="font-manrope text-gray-400 mt-4">
              Ultimo aggiornamento: Gennaio 2024
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="prose prose-invert max-w-none
            prose-headings:font-barlow prose-headings:uppercase prose-headings:tracking-tight
            prose-h2:text-2xl prose-h2:text-white prose-h2:mt-12 prose-h2:mb-4 prose-h2:border-b prose-h2:border-revo-border prose-h2:pb-4
            prose-h3:text-lg prose-h3:text-revo-orange prose-h3:mt-8 prose-h3:mb-3
            prose-p:font-manrope prose-p:text-gray-400 prose-p:leading-relaxed
            prose-ul:font-manrope prose-ul:text-gray-400
            prose-li:marker:text-revo-orange
            prose-strong:text-white"
          >
            <h2>1. Titolare del Trattamento</h2>
            <p>
              Il Titolare del trattamento dei dati personali è:
            </p>
            <p>
              <strong>Revogreen srl</strong><br />
              Via Alberto Dominutti, 6<br />
              37135 Verona (VR)<br />
              P.IVA: 05121010234<br />
              Email: privacy@revoquota.com
            </p>

            <h2>2. Tipologie di Dati Raccolti</h2>
            <p>
              I dati personali raccolti da questo sito web, in modo autonomo o tramite terze parti, includono:
            </p>
            <ul>
              <li>Dati identificativi (nome, cognome, ragione sociale)</li>
              <li>Dati di contatto (email, telefono, indirizzo)</li>
              <li>Dati tecnici (cookies, dati di utilizzo, indirizzo IP)</li>
              <li>Dati relativi alle richieste di preventivo</li>
            </ul>

            <h2>3. Finalità del Trattamento</h2>
            <p>
              I dati personali sono trattati per le seguenti finalità:
            </p>
            <h3>3.1 Erogazione del servizio</h3>
            <p>
              Rispondere alle richieste di contatto e preventivo, fornire assistenza e supporto tecnico.
            </p>
            <h3>3.2 Adempimenti contrattuali</h3>
            <p>
              Gestire il rapporto contrattuale, fatturazione e assistenza post-vendita.
            </p>
            <h3>3.3 Obblighi di legge</h3>
            <p>
              Adempiere agli obblighi previsti dalla legge, regolamenti, normativa comunitaria.
            </p>
            <h3>3.4 Marketing (previo consenso)</h3>
            <p>
              Invio di comunicazioni commerciali e promozionali relative ai servizi offerti.
            </p>

            <h2>4. Base Giuridica del Trattamento</h2>
            <p>
              Il trattamento dei dati personali si basa su:
            </p>
            <ul>
              <li>Consenso dell'interessato</li>
              <li>Esecuzione di un contratto o misure precontrattuali</li>
              <li>Adempimento di obblighi legali</li>
              <li>Legittimo interesse del titolare</li>
            </ul>

            <h2>5. Modalità di Trattamento</h2>
            <p>
              I dati personali sono trattati con strumenti automatizzati per il tempo strettamente necessario 
              a conseguire gli scopi per cui sono stati raccolti. Sono adottate misure di sicurezza adeguate 
              per prevenire accessi non autorizzati, divulgazione, modifica o distruzione dei dati.
            </p>

            <h2>6. Comunicazione e Diffusione</h2>
            <p>
              I dati personali possono essere comunicati a:
            </p>
            <ul>
              <li>Collaboratori e dipendenti autorizzati al trattamento</li>
              <li>Fornitori di servizi tecnici (hosting, email, CRM)</li>
              <li>Consulenti e professionisti esterni</li>
              <li>Autorità pubbliche quando richiesto dalla legge</li>
            </ul>
            <p>
              I dati non saranno diffusi pubblicamente né ceduti a terzi per finalità commerciali proprie.
            </p>

            <h2>7. Conservazione dei Dati</h2>
            <p>
              I dati personali sono conservati per il tempo necessario al conseguimento delle finalità 
              per cui sono stati raccolti, e comunque:
            </p>
            <ul>
              <li>Dati contrattuali: 10 anni dalla conclusione del rapporto</li>
              <li>Dati fiscali: 10 anni come previsto dalla normativa fiscale</li>
              <li>Dati di contatto per marketing: fino a revoca del consenso</li>
              <li>Dati di navigazione: 24 mesi</li>
            </ul>

            <h2>8. Diritti dell'Interessato</h2>
            <p>
              Ai sensi del Regolamento UE 2016/679 (GDPR), l'interessato ha diritto di:
            </p>
            <ul>
              <li>Accedere ai propri dati personali</li>
              <li>Ottenere la rettifica dei dati inesatti</li>
              <li>Ottenere la cancellazione dei dati</li>
              <li>Limitare il trattamento dei dati</li>
              <li>Opporsi al trattamento</li>
              <li>Portabilità dei dati</li>
              <li>Revocare il consenso in qualsiasi momento</li>
              <li>Proporre reclamo all'Autorità Garante</li>
            </ul>
            <p>
              Per esercitare i propri diritti, l'interessato può inviare una comunicazione 
              all'indirizzo email: privacy@revoquota.com
            </p>

            <h2 id="condizioni">9. Condizioni d'Uso</h2>
            <p>
              L'utilizzo di questo sito web implica l'accettazione delle presenti condizioni. 
              Il sito è di proprietà di Revogreen srl. I contenuti, inclusi testi, immagini, 
              grafica e marchi, sono protetti dalle leggi sul diritto d'autore e sulla proprietà 
              intellettuale.
            </p>
            <p>
              È vietata la riproduzione, distribuzione o utilizzo dei contenuti senza 
              autorizzazione scritta del titolare.
            </p>

            <h2>10. Modifiche alla Privacy Policy</h2>
            <p>
              Il Titolare si riserva il diritto di apportare modifiche alla presente Privacy Policy 
              in qualsiasi momento, dandone informazione agli Utenti su questa pagina. 
              Si prega di consultare regolarmente questa pagina.
            </p>

            <h2>11. Contatti</h2>
            <p>
              Per qualsiasi informazione relativa alla presente Privacy Policy, è possibile contattare 
              il Titolare del trattamento:
            </p>
            <p>
              <strong>Revogreen srl</strong><br />
              Email: privacy@revoquota.com<br />
              PEC: revogreen@pec.it<br />
              Tel: +39 045 000 0000
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;
